import AsyncStorage from '@react-native-async-storage/async-storage';

export const ADMIN_TENANTS = ['admintools', 'scadmintools'];
export const ADMIN_LANDING_ROUTE = 'AdminTenants';
export const CUSTOMER_LANDING_ROUTE = 'ScanPack';

// Server-reported current_tenant only, never the typed tenant string (GROOV-5184 / KTD6).
export function isAdminTenant(userInfo) {
  return ADMIN_TENANTS.includes(userInfo?.current_tenant);
}

export function getLandingRoute(userInfo) {
  return isAdminTenant(userInfo) ? ADMIN_LANDING_ROUTE : CUSTOMER_LANDING_ROUTE;
}

export async function readPersistedUserInfo() {
  const raw = await AsyncStorage.getItem('userInfo');
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    return null;
  }
}
